import { fadeInAnimationLong, fadeInAnimationShort, styles } from 'consts';
import styled from 'styled-components';

const { animationLong, animationShort, white, primaryBlack, blueSecondary } = styles;

export const FinalPendingScreenContainer = styled.div`
  border-radius: 0.5rem;
  background: ${white};
  text-align: center;
  color: ${white};
  padding: 2.5rem;
`;

export const FinalPendingScreenWrapper = styled.div`
  animation: ${animationShort};
  ${fadeInAnimationShort};
`;

export const FinalPendingScreenStatus = styled.div`
  max-width: 285px;
  margin: 0 auto;
  line-height: 1.25;
  text-align: center;
  color: ${blueSecondary};
  font-size: 2rem;
  font-weight: bold;
`;

export const FinalPendingScreenIcon = styled.div`
  animation: ${animationLong};
  ${fadeInAnimationLong};
  img {
    width: 12.5rem;
    height: 9.375rem;
  }
`;

export const FinalPendingScreenStatusText = styled.div`
  color: ${primaryBlack};
  font-size: 1rem;
  line-height: 1.32;
  margin-bottom: 2.1875rem;
  max-width: 25rem;
  margin: 0 auto;
  font-weight: 600;
  margin-bottom: 1rem;
`;

export const FinalPendingScreenButton = styled.div`
  position: relative;
  display: inline-block;
  border-radius: 0.6875rem;
  overflow: hidden;
  button {
    background-color: ${blueSecondary};
    border-color: ${blueSecondary};
    border-radius: 0.6875rem;
    color: ${white};
    padding: 0.625rem 4.5rem;
    font-size: 1rem;
    font-weight: bold;
    line-height: 1.125rem;
    text-transform: uppercase;
    font-family: 'mBank';
    outline: none;
    cursor: pointer;
  }
`;
